import { render, staticRenderFns } from "./CMS_Home.vue?vue&type=template&id=70df18fd&"
import script from "./CMS_Home.vue?vue&type=script&lang=js&"
export * from "./CMS_Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports